// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"7126226c","329":"75080940","453":"ffed4807","620":"ffebda4f","936":"1eaabbe8"}[chunkId] + ".chunk.js";
};